export default __webpack_public_path__ + "static/media/sphere-expand.fd5ad41c.png";